import React, { Component } from 'react';
import { makeObservable, observable, action } from 'mobx';
import { observer } from "mobx-react";
import AppStore from 'Stores/AppStore';
import UserMetricsStore from 'Stores/Metrics/UserMetricsStore';
import 'Styles/Metrics.scss';
import 'Styles/Stats.scss';
import queryString from 'query-string';
import GraphBar from 'Components/Metrics/GraphBar';
import MetricFilters from 'Components/Metrics/MetricFilters';
import FiltersStore from 'Stores/Metrics/FiltersStore';
import { ShowModal, ShowAlert } from "Utils/CommonFunctions";
import LoadView from "Components/Common/loadView";
import ShowFiltersButton from "Components/Common/FiltersPanel/ShowFiltersButton";

class UserMetrics extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        //AppStore.OnMainComponentMount('Статистика по должностному лицу', 'userMetrics');
        AppStore.OnMainComponentMount('Статистика по пользователю', 'userMetrics');

        const params = queryString.parse(this.props.location.search);
        UserMetricsStore.metricUserId = parseInt(params.id);
        //UserMetricsStore.userId = parseInt(params.contactId);
        UserMetricsStore.userId = parseInt(params.userId);

        UserMetricsStore.GetInitData();
        FiltersStore.GetInitData(() => UserMetricsStore.GetData());
    }

    onResize = action(() => {
        if (this.mainNode) {
            UserMetricsStore.graphsWidth = this.mainNode.clientWidth - 20/* scroll */;
        }
    });

    render() {
        if (UserMetricsStore.dataLoading)
            return (
                <LoadView loading={true} />
            );

        return (
            <div
                className="page-with-scroll-elements UserMetrics"
                ref={node => {
                    this.mainNode = node;
                    if (node) {
                        this.onResize();
                        window.addEventListener('resize', () => this.onResize());
                    }
                }}
            >

                <div className="Metrics-top-buttons-container">
                    <ShowFiltersButton
                        className={(UserMetricsStore.dataLoading ? ' disabled' : '')}
                        getFiltersRender={() => FiltersStore.filtersRender}
                        getFilters={() => FiltersStore.filters}
                        clearFilters={() => {
                            FiltersStore.ClearFiltersRender();
                            FiltersStore.SaveFiltersFromRender();
                            UserMetricsStore.GetData();
                        }}
                        search={() => UserMetricsStore.GetData()}
                        getSelectedFiltersCount={() => FiltersStore.GetSelectedFiltersCount()}
                        showFullFilters={() => {
                            ShowModal({
                                className: "Metrics-filters-modal",
                                canBeClosed: true,
                                header: 'Фильтрация данных',
                                children: (<MetricFilters />),
                                buttons: [
                                    {
                                        content: 'Очистить',
                                        closer: false,
                                        onClick: _ => FiltersStore.ClearFiltersRender()
                                    },
                                    {
                                        content: 'Применить',
                                        className: "blue-button",
                                        closer: true,
                                        onClick: _ => {
                                            FiltersStore.SaveFiltersFromRender();
                                            UserMetricsStore.GetData();
                                        }
                                    }
                                ]
                            });
                        }}
                    />
                    <button
                        className={(UserMetricsStore.dataLoading ? ' disabled' : '')}
                        onClick={_ => UserMetricsStore.GetData()}>
                        Обновить
                    </button>
                    <button
                        className={((UserMetricsStore.dataLoading || UserMetricsStore.exportLoading) ? ' disabled' : '')}
                        onClick={_ => UserMetricsStore.ExportUsersData()}>
                        Выгрузить данные
                    </button>
                </div>

                <div className="scroll">
                    <div className="scroll-content-container">

                        <div className="Metrics-table-divider">
                            Количество загруженных документов (РК) и проектов документов (РКПД) в приложение
                        </div>
                        <GraphBar
                            sectionId="documentsLoaded"
                        />

                        <div className="Metrics-table-divider">
                            Количество обработанных документов (РК) и проектов документов (РКПД)
                        </div>
                        <GraphBar
                            sectionId="documentsProcessed"
                        />

                        <div className="Metrics-table-divider">
                            Количество созданных и отредактированных поручений
                        </div>
                        <GraphBar
                            sectionId="resolutionsCreatedOrEdited"
                        />

                        <div className="Metrics-table-divider">
                            Количество введенных отчетов и ознакомлений с документом
                        </div>
                        <GraphBar
                            sectionId="resolutionsExecutorsReports"
                        />

                        <div className="Metrics-table-divider">
                            Количество завизированных и подписанных проектов документов
                        </div>
                        <GraphBar
                            sectionId="documentsProjectsVisasOrSigns"
                        />

                        <div className="Metrics-table-divider">
                            Количество завизированных проектов документов в зависимости от типа визы
                        </div>
                        <GraphBar
                            sectionId="documentsProjectsVisasByType"
                        />

                        <div className="Metrics-table-divider">
                            Количество подписанных проектов документов в зависимости от типа подписи
                        </div>
                        <GraphBar
                            sectionId="documentsProjectsSignsByType"
                        />

                        <div className="Metrics-table-divider">
                            Количество загруженных онлайн-документов (РК) и проектов документов (РКПД)
                        </div>
                        <GraphBar
                            sectionId="documentsLoadedOnline"
                        />

                        <div className="Metrics-table-divider">
                            Количество загруженных файлов в приложение
                        </div>
                        <GraphBar
                            sectionId="filesLoaded"
                        />

                    </div>
                </div>
            </div>
        );
    }
}

export default observer(UserMetrics);